import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class ExcelService {

  constructor() { }

  /**
   * @description This method will generate excel sheet
   * @param data
   * @param fileName 
   * @param sheetName 
   * @param columnWidth
   */
  public ExportToExcel(data: any[], fileName: string, sheetName: string, columnWidth: number = 10): void {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, sheetName);

    // Fixed column width
    const wsCols = new Array(Object.keys(data[0]).length).fill({wch: columnWidth});
    ws['!cols'] = wsCols;

    const wout: string | ArrayBuffer = XLSX.write(wb, {bookType: 'xlsx', type: 'array'});
    saveAs(new Blob([wout], {type: 'application/octet-stream'}), `${fileName}.xlsx`);
  }
}
